import React, { useState } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { useNavigate, useLocation } from "react-router-dom";
const baseURL = process.env.REACT_APP_API_JOBS;

const Edit = ({ advType, handleCancelClick, increment, setAdvTypeId }) => {
  const [advType1, setAdvType1] = useState(advType);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    setAdvType1({ id: advType1.id, title: e.target.value }); // set name to e.target.value (event)
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "advtype/" + advType1.id + "/",
          advType1,
          {
            signal: controller.signal,
          }
        );
        increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
    setAdvTypeId(null);
  };
  return (
    <tr>
      <td>{advType.id}</td>
      <td>
        <input
          type="text"
          name="title"
          className="form-control"
          id="title"
          value={advType1.title}
          onChange={handleChange}
        />
      </td>
      <td>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSubmit}
        >
          שמירה
        </button>
        <span> </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelClick}
        >
          ביטול
        </button>
      </td>
    </tr>
  );
};

export default Edit;
